import { render, staticRenderFns } from "./taxCustomer.vue?vue&type=template&id=0f798a4c&scoped=true"
import script from "./taxCustomer.vue?vue&type=script&lang=js"
export * from "./taxCustomer.vue?vue&type=script&lang=js"
import style0 from "./taxCustomer.vue?vue&type=style&index=0&id=0f798a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f798a4c",
  null
  
)

export default component.exports